/* src/app/hire-person-search/hire-candidate-slider/hire-slider-activity-view/hire-slider-activity-view.component.scss */
.dropdown-caret,
.dropdown-caret2 {
  position: relative;
  width: fit-content;
}
.dropdown-caret::after,
.dropdown-caret2::after {
  content: "";
  display: flex;
  position: absolute;
  right: 3px;
  top: 5px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
.custom-select {
  min-width: 50px;
  width: 100px;
  padding: 4px 6px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  color: #484b59;
}
.custom-select:focus {
  outline: none;
  border-color: #007bff;
}
select.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100px;
}
.dropdown-caret2 .custom-select {
  min-width: 90px;
  max-width: 110px;
  width: 110px;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.paddingBottom {
  padding-bottom: 300px;
}
.text-wrap {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
/*# sourceMappingURL=hire-slider-activity-view.component-ZIBOQKJY.css.map */
